import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views - Pages
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const ResetPassword = () => import('@/views/pages/ResetPassword')
const ForgotPassword = () => import('@/views/pages/ForgotPassword')
const Authentication = () => import('@/views/pages/Authentication')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

// App
const Diagnosis = () => import('@/views/diagnosis/Diagnosis')

Vue.use(Router)

export default new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  mode: 'history',
  base: '/',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/app/color',
      redirect: '/app/color/login',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
      ]
    },
    {
      path: '/app/color',
      redirect: '/app/color/login',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'diagnosis',
          name: 'Diagnosis',
          component: Diagnosis
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'reset_password/:token',
          name: 'ResetPassword',
          component: ResetPassword
        },
        {
          path: 'forgot_password',
          name: 'ForgotPassword',
          component: ForgotPassword
        },
        {
          path: 'authentication/:token',
          name: 'Authentication',
          component: Authentication
        },
      ]
    }
  ]
}

